module.exports = __webpack_public_path__ + "static/images/styles/images/reserves/journal/requisition-cancel.59281a3d.png";


//////////////////
// WEBPACK FOOTER
// ./styles/images/reserves/journal/requisition-cancel.png
// module id = 3746
// module chunks = 11